import { baseApi } from '@/store/api/base.api';

export const partnerApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getPartners: builder.query<any, string>({
			query: (query) => ({
				url: `/partners?${query}`,
				method: 'GET',
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useGetPartnersQuery } = partnerApi;
